// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__kBwX_","compliance-overlay-text":"style_compliance-overlay-text__LO7rF"};